import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const addCCEmailsToTicket = createAsyncThunk(
  'ticket/addCCEmailsToTicket',
  async ({ ticketId, ccEmails }, { rejectWithValue, getState }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    const business_id = loginToken?.response?.user?.business_id;
    try {
      const response = await axios.patch(
        `${ROOT_URL}/ticket/${ticketId}/${business_id}/ccEmails/add`,
        { ccEmails },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { ticketId, ccEmails, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const addCCEmailsToTicketSlice = createSlice({
  name: 'addCCEmailsToTicket',
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCCEmailsToTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addCCEmailsToTicket.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(addCCEmailsToTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default addCCEmailsToTicketSlice.reducer; 